/* @flow */

import Reflux from "reflux";

import { SessionStore } from "shared/src/uidispatcherapi/SessionStore";
import TrackingUtil from "shared/src/utils/TrackingUtil";
import NavigationMenuClient from "../clients/NavigationMenuClient";
import { NavigationMenu } from "../datatypes/NavigationMenu";
import CustomerStore from "./CustomerStore";
import CountryUtil from "shared/src/uidispatcherapi/CountryUtil";

type Result = {
    navigationMenu: NavigationMenu | undefined | null;
};

let _result: Result;
let currentCountry: string | undefined | null;
let currentLocale: string | undefined | null;
let currentCustomerStore: string | undefined | null;
let currentCustomerId: string | undefined | null;
let currentCustomerIsFsdCustomer: boolean | undefined | null;

export default Reflux.createStore({
    init() {
        _result = this.getInitialState();
        currentCountry = undefined;
        currentLocale = undefined;
        currentCustomerStore = undefined;
        currentCustomerId = undefined;
        currentCustomerIsFsdCustomer = undefined;
        this.navigationmenuAlreadyLoading = false;
        this.listenTo(SessionStore, this.onSessionStoreTrigger);
        this.listenTo(CustomerStore, this.onCustomerStoreTrigger);
        this.onSessionStoreTrigger();
    },

    getInitialState(): Result {
        return {
            navigationMenu: undefined
        };
    },

    onSessionStoreTrigger() {
        const country: string = SessionStore.getCountry();
        const locale: string = SessionStore.getLocale();
        const customerStore: string = SessionStore.getCustomerStore();
        const customerId: string = SessionStore.getCustomerId();
        if (
            (country !== currentCountry ||
                locale !== currentLocale ||
                customerStore !== currentCustomerStore ||
                customerId !== currentCustomerId) &&
            !SessionStore.pending()
        ) {
            _result.navigationMenu = undefined;
            currentCountry = country;
            currentLocale = locale;
            currentCustomerStore = customerStore;
            currentCustomerId = customerId;
            this.loadNavigationMenu();
        }
    },

    onCustomerStoreTrigger() {
        const newCustomerIsFsdCustomer = CustomerStore.isCurrentCustomerFsdCustomer();
        if (currentCustomerIsFsdCustomer !== newCustomerIsFsdCustomer) {
            currentCustomerIsFsdCustomer = CustomerStore.isCurrentCustomerFsdCustomer();
            _result.navigationMenu = undefined;
            this.loadNavigationMenu();
        }
    },

    loadNavigationMenu() {
        if (_result.navigationMenu) {
            this.trigger();
            return;
        }
        if (!SessionStore.getCustomerStore() || !SessionStore.getCountry() || !SessionStore.getLocale()) {
            return;
        }

        if (!this.navigationmenuAlreadyLoading) {
            this.navigationmenuAlreadyLoading = true;
            NavigationMenuClient.getNavigationMenu(
                SessionStore.getCountry(),
                SessionStore.getLocale(),
                SessionStore.getCustomerStore(),
                SessionStore.getCustomerId()
            )
                .then(this.setNavigationMenu)
                .catch(this.getNavigationMenuFailed);
        }
    },

    getNavigationMenu() {
        return _result;
    },

    setNavigationMenu(result: NavigationMenu) {
        this.navigationmenuAlreadyLoading = false;
        _result.navigationMenu = result;
        if (
            !currentCustomerIsFsdCustomer &&
            _result.navigationMenu.personal &&
            CountryUtil.getOptionalConfig().disableOrderForNonFsd
        ) {
            _result.navigationMenu.personal = _result.navigationMenu.personal.filter((item) => item.id !== "orders");
        }
        this.trigger();
    },

    getNavigationMenuFailed(err: unknown) {
        this.navigationmenuAlreadyLoading = false;
        _result.navigationMenu = undefined;
        TrackingUtil.trackUiErrorSd("NavigationMenuStore", "getNavigationMenu failed.", err);
        // retry in 1 minute
        setTimeout(() => this.loadNavigationMenu(), 1000 * 60);
    }
});
